// import React, { useEffect, useState, useCallback } from "react";
// import {
//     flexRender,
//     getCoreRowModel,
//     getSortedRowModel,
//     useReactTable,
//     getFilteredRowModel,
// } from "@tanstack/react-table";
// import { useVirtual } from "@tanstack/react-virtual";
// import { DebouncedInput, IndeterminateCheckbox } from "../../Common/Filters";
// import JSZip from "jszip";
// import {
//     ArrowDownTrayIcon,
//     ArrowDownCircleIcon,
//     EyeIcon,
//     FolderArrowDownIcon,
// } from "@heroicons/react/24/outline";
// import ReadModal from "../../Common/ReadModal";
// import {
//     generateFileNameDated,
//     generateProcessCodeFileName,
// } from "../../Common/CommonUtils";

// export default function TranscriptionProcess({
//     startProcess,
//     selectedFilesToProcess,
// }) {
//     let [isOpenRead, setIsOpenRead] = useState(false);
//     let [rowData, setRowData] = useState([]);
//     let [modalTitle, setModalTitle] = useState(false);

//     const [data, setData] = useState([]);

//     useEffect(() => {
//         setData(selectedFilesToProcess);
//     }, [selectedFilesToProcess]);

//     function closeReadModal() {
//         setIsOpenRead(false);
//     }

//     function openReadModal(e, contentType) { 
//         let modalData = {};
//         if (e && e.response) {
//             if (contentType === "response") {
//                 if ("original_lang_transcribed_text" in e.response) {
//                     const { original_lang_transcribed_text, ...rest } = e.response;
//                     modalData = rest;
//                 } else {
//                     modalData = { ...e.response };
//                 }
//             } else if (contentType === "originalText") {
//                 if ("original_lang_transcribed_text" in e.response) {
//                     modalData = e.response.original_lang_transcribed_text;
//                 } else {
//                     modalData = "No original transcript available";
//                 }
//             }
//         } else {
//             modalData = "No response available";
//         }
//         setRowData(modalData);
//         setModalTitle(
//             contentType === "response"
//                 ? `Response of ${e.name}`
//                 : `Original Transcript of ${e.name}`
//         );
//         setIsOpenRead(true);
//     }
    

//     const formattedDate = useCallback((dateStr) => {
//         const date = new Date(dateStr);
//         const formattedDateString = date
//             .toLocaleString("en-US", {
//                 day: "2-digit",
//                 month: "2-digit",
//                 year: "numeric",
//                 hour: "2-digit",
//                 minute: "2-digit",
//                 second: "2-digit",
//                 hour12: false,
//             })
//             .replace(/\//g, "/")
//             .replace(",", " ");
//         const [month, day, yearAndTime] = formattedDateString.split("/");
//         return `${day}-${month}-${yearAndTime}`;
//     }, []);

//     const [sorting, setSorting] = React.useState([]);
//     const [globalFilter, setGlobalFilter] = React.useState("");
//     const [rowSelection, setRowSelection] = React.useState({});

//     const downloadFiles = useCallback(async () => {
//         const zip = new JSZip();

//         // Add each JSON file to the zip
//         const selectedProcessedFiles = Object.keys(rowSelection)
//             .filter((index) => rowSelection[index])
//             .map((index) => data[index]);
//         if (selectedProcessedFiles.length > 0) {
//             selectedProcessedFiles.forEach((file) => {
//                 if (file.response && file.response.transcribed_text) {
//                     const content = JSON.stringify(file.response);
//                     zip.file(
//                         `${generateFileNameDated(
//                             file.name,
//                             file.last_modified
//                         )}.json`,
//                         content
//                     );
//                 }
//             });
//         } else {
//             selectedFilesToProcess.forEach((file) => {
//                 if (file.response && file.response.transcribed_text) {
//                     const content = JSON.stringify(file.response);
//                     zip.file(
//                         `${generateFileNameDated(
//                             file.name,
//                             file.last_modified
//                         )}.json`,
//                         content
//                     );
//                 }
//             });
//         }

//         // Generate the zip file
//         const zipContent = await zip.generateAsync({ type: "blob" });

//         // Create a download link and trigger the download
//         const downloadLink = document.createElement("a");
//         downloadLink.href = URL.createObjectURL(zipContent);
//         downloadLink.download = `${sessionStorage.getItem(
//             "processName"
//         )}_${sessionStorage.getItem("projectName")}.zip`;
//         downloadLink.click();
//     }, [selectedFilesToProcess, data, rowSelection]);

//     const TextDownloadButton = ({ disabled, content, fileName }) => {
//         const downloadTxt = () => {
//             const blob = new Blob([JSON.stringify(content)], {
//                 type: "text/plain",
//             });
//             const link = document.createElement("a");
//             link.href = window.URL.createObjectURL(blob);
//             link.download = fileName + ".txt";
//             link.click();
//         };

//         return (
//             <button
//                 className="p-1 rounded-md border disabled:text-gray-300"
//                 disabled={disabled}
//                 onClick={downloadTxt}
//             >
//                 <p className="flex gap-1" title="txt file download">
//                     <ArrowDownTrayIcon className="h-5" />
//                 </p>
//             </button>
//         );
//     };

//     const JsonDownloadButton = ({ disabled, content, fileName }) => {
//         const downloadJson = () => {
//             const blob = new Blob([JSON.stringify(content)], {
//                 type: "application/json",
//             });
//             const link = document.createElement("a");
//             link.href = window.URL.createObjectURL(blob);
//             link.download = fileName + ".json";
//             link.click();
//         };

//         return (
//             <button
//                 className="p-1 rounded-md border disabled:text-gray-300"
//                 disabled={disabled}
//                 onClick={downloadJson}
//             >
//                 <p className="flex gap-1" title="json file download">
//                     <ArrowDownCircleIcon className="h-5" />
//                 </p>
//             </button>
//         );
//     };

//     const columns = React.useMemo(
//         () => [
//             {
//                 id: "select",
//                 size: 10,
//                 header: ({ table }) => (
//                     <IndeterminateCheckbox
//                         {...{
//                             checked: table.getIsAllRowsSelected(),
//                             indeterminate: table.getIsSomeRowsSelected(),
//                             onChange: table.getToggleAllRowsSelectedHandler(),
//                         }}
//                     />
//                 ),
//                 cell: ({ row }) => (
//                     <center className="px-1">
//                         <IndeterminateCheckbox
//                             {...{
//                                 checked: row.getIsSelected(),
//                                 disabled: !row.getCanSelect(),
//                                 indeterminate: row.getIsSomeSelected(),
//                                 onChange: row.getToggleSelectedHandler(),
//                             }}
//                         />
//                     </center>
//                 ),
//             },
//             {
//                 accessorKey: "index",
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 size: 50,
//                 header: "#",
//                 cell: ({ row }) => <center>{row.index + 1}</center>,
//             },
//             {
//                 accessorKey: "name",
//                 enableColumnFilter: false,
//                 size: 1000,
//                 header: () => <span>File Name</span>,
//             },
//             {
//                 accessorKey: "start_date_time",
//                 enableColumnFilter: false,
//                 size: 100,
//                 header: "Start Date",
//                 cell: ({ row }) => <div>{row.original.start_date_time}</div>,
//             },
//             {
//                 accessorKey: "last_modified",
//                 enableColumnFilter: false,
//                 size: 100,
//                 header: "End Date",
//                 cell: ({ row }) => (
//                     <div>{row.original.last_modified !== "" && formattedDate(row.original.last_modified)}</div>
//                 ),
//             },
//             {
//                 accessorKey: "status",
//                 header: "Status",
//                 size: 50,
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: ({ row }) => (
//                     <div className="flex justify-center">
//                         <div
//                             className={`${row.original.status === "success" &&
//                                 "bg-green-500"
//                                 } ${row.original.status === "error" && "bg-red-500"
//                                 } ${row.original.status === "Inprogress" &&
//                                 "bg-blue-500"
//                                 }  ${row.original.status !== "success" &&
//                                 row.original.status !== "error" &&
//                                 row.original.status !== "Inprogress" &&
//                                 "bg-yellow-500"
//                                 } 
//                             text-white text-xs w-fit px-2 py-1 font-bold rounded-xl flex flex-nowrap`}
//                         >
//                             {row.original.status === "Inprogress" && (
//                                 <div className="h-3 w-3 border-t-transparent border-solid animate-spin rounded-full border-white border-2 me-1 mt-0.5"></div>
//                             )}
//                             {row.original.status && row.original.status}
//                             {!row.original.status && "Waiting"}
//                             {row.original.status === "Inprogress" && "..."}
//                         </div>
//                     </div>
//                 ),
//             },
//             {
//                 accessorKey: "transcription_model",
//                 enableColumnFilter: false,
//                 size: 100,
//                 header: "Model",
//                 cell: ({ row }) => (
//                     <div>{row.original.transcription_model}</div>
//                 ),
//             },
//             {
//                 accessorKey: "id",
//                 header: "Actions",
//                 size: 50,
//                 enableColumnFilter: false,
//                 enableSorting: false,
//                 cell: ({ row }) => (
//                     <div className="flex gap-2 items-center justify-center">
//                         <TextDownloadButton
//                             disabled={row.original.response ? false : true}
//                             content={row.original.response}
//                             fileName={generateProcessCodeFileName(
//                                 row.original.name,
//                                 row.original.last_modified
//                             )}
//                         />
//                         <JsonDownloadButton
//                             disabled={row.original.response ? false : true}
//                             content={row.original.response}
//                             fileName={generateProcessCodeFileName(
//                                 row.original.name,
//                                 row.original.last_modified
//                             )}
//                         />
//                         <button
//                             className="p-1 rounded-md border disabled:text-gray-300 text-green-800"
//                             disabled={row.original.response ? false : true}
//                             onClick={() =>
//                                 openReadModal(row.original, "response")
//                             }
//                             title="view response"
//                         >
//                             <EyeIcon className="h-5" />
//                         </button>
//                         <button
//                             className="p-1 rounded-md border disabled:text-gray-300 text-blue-800"
//                             disabled={row.original.response ? false : true}
//                             onClick={() => openReadModal(row.original, "originalText")}
//                             title="original transcribe text"
//                         >
//                             <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-type"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /><path d="M9 13v-1h6v1" /><path d="M12 12v6" /><path d="M11 18h2" /></svg>
//                         </button>
//                     </div>
//                 ),
//             },
//         ],
//         [formattedDate]
//     );

//     const table = useReactTable({
//         data,
//         columns,
//         state: {
//             rowSelection,
//             sorting,
//             globalFilter,
//         },
//         enableRowSelection: true,
//         onRowSelectionChange: setRowSelection,
//         onGlobalFilterChange: setGlobalFilter,
//         onSortingChange: setSorting,
//         getCoreRowModel: getCoreRowModel(),
//         getSortedRowModel: getSortedRowModel(),
//         getFilteredRowModel: getFilteredRowModel(),
//     });

//     const tableContainerRef = React.useRef(null);
//     function Filter({ column }) {
//         const columnFilterValue = column.getFilterValue();

//         return (
//             <input
//                 type="text"
//                 value={columnFilterValue || ""}
//                 onChange={(e) => column.setFilterValue(e.target.value)}
//                 placeholder={`Search...`}
//                 className="w-full border rounded-md text-xs"
//             />
//         );
//     }

//     const { rows } = table.getRowModel();
//     const rowVirtualizer = useVirtual({
//         parentRef: tableContainerRef,
//         size: rows.length,
//         overscan: data.length,
//     });
//     const { virtualItems: virtualRows, totalSize } = rowVirtualizer;

//     const paddingTop = virtualRows.length > 0 ? virtualRows[0]?.start || 0 : 0;
//     const paddingBottom =
//         virtualRows.length > 0
//             ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
//             : 0;

//     return (
//         <div className="m-2 border rounded-lg bg-white font-GoogleSans tracking-wider overflow-hidden">
//             <ReadModal
//                 isOpen={isOpenRead}
//                 closeModal={closeReadModal}
//                 title={modalTitle}
//                 modalInputs={
//                     <div className="overflow-auto h-[calc(100vh-8rem)] md:h-[calc(100vh-8rem)]">
//                         <pre className="pretxtwrap text-sm">
//                             {JSON.stringify(rowData, null, 2)}
//                         </pre>
//                     </div>
//                 }
//             />
//             {selectedFilesToProcess.length === 0 && (
//                 <p className="px-3 py-4">
//                     Please select the files for the transcription process.
//                 </p>
//             )}
//             {selectedFilesToProcess.length > 0 && (
//                 <>
//                     <div className="flex justify-between m-3 gap-2">
//                         <DebouncedInput
//                             value={globalFilter ?? ""}
//                             onChange={(value) => setGlobalFilter(String(value))}
//                             placeholder="Search..."
//                         />
//                     </div>
//                     <div
//                         ref={tableContainerRef}
//                         className="overflow-auto resp-processtable-h"
//                     >
//                         <table className="flex-inline w-full border-collapse">
//                             <thead className="bg-gray-200 border-b">
//                                 {table.getHeaderGroups().map((headerGroup) => (
//                                     <tr key={headerGroup.id}>
//                                         {headerGroup.headers.map((header) => {
//                                             return (
//                                                 <th
//                                                     className="border p-3 whitespace-nowrap"
//                                                     key={header.id}
//                                                     colSpan={header.colSpan}
//                                                     style={{
//                                                         width: header.getSize(),
//                                                     }}
//                                                 >
//                                                     {header.isPlaceholder ? null : (
//                                                         <>
//                                                             <div
//                                                                 className={`${header.column.getCanSort()
//                                                                     ? "cursor-pointer select-none justify-start"
//                                                                     : "justify-center"
//                                                                     } flex`}
//                                                                 onClick={header.column.getToggleSortingHandler()}
//                                                             >
//                                                                 {flexRender(
//                                                                     header
//                                                                         .column
//                                                                         .columnDef
//                                                                         .header,
//                                                                     header.getContext()
//                                                                 )}
//                                                                 {{
//                                                                     asc: " 🔼",
//                                                                     desc: " 🔽",
//                                                                 }[
//                                                                     header.column.getIsSorted()
//                                                                 ] || null}
//                                                             </div>
//                                                             {header.column.getCanFilter() ? (
//                                                                 <div className="mt-2">
//                                                                     <Filter
//                                                                         column={
//                                                                             header.column
//                                                                         }
//                                                                         table={
//                                                                             table
//                                                                         }
//                                                                     />
//                                                                 </div>
//                                                             ) : null}
//                                                         </>
//                                                     )}
//                                                 </th>
//                                             );
//                                         })}
//                                     </tr>
//                                 ))}
//                             </thead>
//                             <tbody>
//                                 {
//                                     rows.length === 0 ?
//                                         (
//                                             <tr>
//                                                 <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
//                                                     No Data Found
//                                                 </td>
//                                             </tr>
//                                         )
//                                         :
//                                         (
//                                             <>
//                                                 {paddingTop > 0 && (
//                                                     <tr>
//                                                         <td
//                                                             className="border p-3"
//                                                             style={{
//                                                                 height: `${paddingTop}px`,
//                                                             }}
//                                                         />
//                                                     </tr>
//                                                 )}
//                                                 {virtualRows.map((virtualRow) => {
//                                                     const row = rows[virtualRow.index];
//                                                     return (
//                                                         <tr
//                                                             key={row.id}
//                                                             className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100"
//                                                         >
//                                                             {row
//                                                                 .getVisibleCells()
//                                                                 .map((cell) => {
//                                                                     return (
//                                                                         <td
//                                                                             className="border p-2 whitespace-nowrap"
//                                                                             key={cell.id}
//                                                                         >
//                                                                             {flexRender(
//                                                                                 cell.column
//                                                                                     .columnDef
//                                                                                     .cell,
//                                                                                 cell.getContext()
//                                                                             )}
//                                                                         </td>
//                                                                     );
//                                                                 })}
//                                                         </tr>
//                                                     );
//                                                 })}
//                                                 {paddingBottom > 0 && (
//                                                     <tr>
//                                                         <td
//                                                             className="border p-3"
//                                                             style={{
//                                                                 height: `${paddingBottom}px`,
//                                                             }}
//                                                         />
//                                                     </tr>
//                                                 )}
//                                             </>
//                                         )
//                                 }
//                             </tbody>
//                         </table>
//                     </div>
//                 </>
//             )}
//             {data.length > 0 && !startProcess && (
//                 <div className="flex gap-2 justify-start m-3">
//                     <button
//                         type="button"
//                         onClick={downloadFiles}
//                         className="inline-flex justify-center rounded-lg border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
//                     >
//                         <FolderArrowDownIcon
//                             className="h-4"
//                             title="Download zip file"
//                         />{" "}
//                         &nbsp;Download
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// }

import React, { useEffect, useState, useCallback, useRef } from "react";
import {
    flexRender,
    getCoreRowModel,
    getSortedRowModel,
    useReactTable,
    getFilteredRowModel,
} from "@tanstack/react-table";
// import { useVirtual } from '@tanstack/react-virtual';
import { useVirtualizer } from '@tanstack/react-virtual';
import { DebouncedInput, IndeterminateCheckbox } from "../../Common/Filters";
import JSZip from "jszip";
import {
    ArrowDownTrayIcon,
    ArrowDownCircleIcon,
    EyeIcon,
    FolderArrowDownIcon,
    ClockIcon,
    ArrowPathIcon,
} from "@heroicons/react/24/outline";
import ReadModal from "../../Common/ReadModal";
import {
    generateFileNameDated,
    generateProcessCodeFileName,
} from "../../Common/CommonUtils";
import { TRANSCRIPT_URL } from "../../../imports";
import axios from "axios";

export default function TranscriptionProcess({
    startProcess,
    selectedFilesToProcess,
}) {
    let [isOpenRead, setIsOpenRead] = useState(false);
    let [rowData, setRowData] = useState([]);
    let [modalTitle, setModalTitle] = useState(false);
    const [data, setData] = useState([]);
    const [pollingFiles, setPollingFiles] = useState(new Set());
    const pollingIntervals = useRef({});

    useEffect(() => {
        setData(selectedFilesToProcess);
        
        // Start polling for submitted files
        selectedFilesToProcess.forEach(file => {
            if (file.status === "submitted" && file.file_code) {
                startPollingForFile(file.file_code);
            }
        });

        // Cleanup on unmount
        return () => {
            Object.values(pollingIntervals.current).forEach(interval => {
                clearInterval(interval);
            });
        };
    }, [selectedFilesToProcess]);

    // ✅ Poll for transcription status
    const checkTranscriptionStatus = async (fileCode) => {
        try {
            const response = await axios.get(
                `${TRANSCRIPT_URL}/transcribe/status/${sessionStorage.getItem("projectCode")}/${fileCode}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                }
            );

            const statusData = response.data;
            
            if (statusData.status === "completed") {
                // Update the file in data with completed results
                updateFileStatus(fileCode, {
                    status: "success",
                    response: statusData.data,
                    last_modified: new Date(),
                    transcription_model: statusData.data.transcription_model || "openai"
                });
                
                // Stop polling for this file
                stopPollingForFile(fileCode);
                
                console.log(`✅ Transcription completed for ${fileCode}`);
            } else if (statusData.status === "failed") {
                updateFileStatus(fileCode, {
                    status: "error",
                    response: { error: statusData.error },
                    last_modified: new Date()
                });
                
                stopPollingForFile(fileCode);
                console.error(`❌ Transcription failed for ${fileCode}`);
            } else {
                // Still processing, update status message
                updateFileStatus(fileCode, {
                    status: "Inprogress",
                    response: { 
                        message: statusData.message || "Processing...",
                        submitted_at: statusData.submitted_at
                    }
                });
            }
        } catch (error) {
            console.error(`Error checking status for ${fileCode}:`, error);
            // Don't stop polling on error, might be temporary network issue
        }
    };

    // ✅ Start polling for a specific file
    const startPollingForFile = (fileCode) => {
        if (pollingIntervals.current[fileCode]) {
            return; // Already polling
        }

        setPollingFiles(prev => new Set([...prev, fileCode]));

        // Poll every 5 seconds
        const interval = setInterval(() => {
            checkTranscriptionStatus(fileCode);
        }, 5000);

        pollingIntervals.current[fileCode] = interval;
        
        // Initial check
        checkTranscriptionStatus(fileCode);
    };

    // ✅ Stop polling for a specific file
    const stopPollingForFile = (fileCode) => {
        if (pollingIntervals.current[fileCode]) {
            clearInterval(pollingIntervals.current[fileCode]);
            delete pollingIntervals.current[fileCode];
        }
        
        setPollingFiles(prev => {
            const newSet = new Set(prev);
            newSet.delete(fileCode);
            return newSet;
        });
    };

    // ✅ Update file status in data
    const updateFileStatus = (fileCode, updates) => {
        setData(prevData => 
            prevData.map(file => 
                file.file_code === fileCode 
                    ? { ...file, ...updates }
                    : file
            )
        );
    };

    // ✅ Manual refresh button for a specific file
    const handleManualRefresh = (fileCode) => {
        checkTranscriptionStatus(fileCode);
    };

    function closeReadModal() {
        setIsOpenRead(false);
    }

    function openReadModal(e, contentType) { 
        let modalData = {};
        
        if (!e || !e.response) {
            modalData = "No response available";
            setRowData(modalData);
            setModalTitle(`${contentType === "response" ? "Response" : "Original Transcript"} of ${e?.name || "Unknown"}`);
            setIsOpenRead(true);
            return;
        }

        if (typeof e.response === 'string') {
            modalData = {
                status: "Processing",
                message: e.response,
                note: "This file is being processed. Results will be available shortly."
            };
            setRowData(modalData);
            setModalTitle(`Status of ${e.name}`);
            setIsOpenRead(true);
            return;
        }

        if (typeof e.response === 'object') {
            if (e.response.message && e.response.submitted_at) {
                modalData = {
                    status: "Processing",
                    message: e.response.message,
                    submitted_at: e.response.submitted_at,
                    note: "Results will be available shortly."
                };
                setRowData(modalData);
                setModalTitle(`Status of ${e.name}`);
                setIsOpenRead(true);
                return;
            }

            if ('original_lang_transcribed_text' in e.response) {
                if (contentType === "response") {
                    const { original_lang_transcribed_text, ...rest } = e.response;
                    modalData = rest;
                } else if (contentType === "originalText") {
                    modalData = e.response.original_lang_transcribed_text;
                }
            } else if (e.response.transcribed_text) {
                if (contentType === "response") {
                    modalData = { ...e.response };
                } else {
                    modalData = e.response.original_lang_transcribed_text || "Original text not available";
                }
            } else {
                modalData = { ...e.response };
            }
        }

        setRowData(modalData);
        setModalTitle(
            contentType === "response"
                ? `Response of ${e.name}`
                : `Original Transcript of ${e.name}`
        );
        setIsOpenRead(true);
    }

    const hasViewableTranscription = (file) => {
        if (!file || !file.response) return false;
        if (typeof file.response === 'string') return true;
        if (typeof file.response === 'object') {
            if (file.response.message) return true;
            if (file.response.transcribed_text) return true;
        }
        return false;
    };

    const hasCompletedTranscription = (file) => {
        if (!file || !file.response) return false;
        if (typeof file.response === 'string') return false;
        if (typeof file.response === 'object') {
            if (file.response.message && !file.response.transcribed_text) return false;
            return file.response.transcribed_text ? true : false;
        }
        return false;
    };

    // const formattedDate = useCallback((dateStr) => {
    //     const date = new Date(dateStr);
    //     const formattedDateString = date
    //         .toLocaleString("en-US", {
    //             day: "2-digit",
    //             month: "2-digit",
    //             year: "numeric",
    //             hour: "2-digit",
    //             minute: "2-digit",
    //             second: "2-digit",
    //             hour12: false,
    //         })
    //         .replace(/\//g, "/")
    //         .replace(",", " ");
    //     const [month, day, yearAndTime] = formattedDateString.split("/");
    //     return `${day}-${month}-${yearAndTime}`;
    // }, []);

    const formattedDate = useCallback((dateStr) => {
        if (!dateStr || dateStr === "") return "";  // ✅ Handle empty dates
        
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "";  // ✅ Handle invalid dates
            
            const formattedDateString = date
                .toLocaleString("en-US", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    hour12: false,
                })
                .replace(/\//g, "/")
                .replace(",", " ");
            const [month, day, yearAndTime] = formattedDateString.split("/");
            return `${day}-${month}-${yearAndTime}`;
        } catch (e) {
            console.error("Date formatting error:", e);
            return "";
        }
    }, []);

    const [sorting, setSorting] = React.useState([]);
    const [globalFilter, setGlobalFilter] = React.useState("");
    const [rowSelection, setRowSelection] = React.useState({});

    const downloadFiles = useCallback(async () => {
        const zip = new JSZip();

        const selectedProcessedFiles = Object.keys(rowSelection)
            .filter((index) => rowSelection[index])
            .map((index) => data[index]);
        
        const filesToDownload = selectedProcessedFiles.length > 0 
            ? selectedProcessedFiles 
            : selectedFilesToProcess;

        let filesAdded = 0;
        filesToDownload.forEach((file) => {
            if (hasCompletedTranscription(file)) {
                const content = JSON.stringify(file.response);
                zip.file(
                    `${generateFileNameDated(file.name, file.last_modified)}.json`,
                    content
                );
                filesAdded++;
            }
        });

        if (filesAdded === 0) {
            alert("No completed transcriptions available to download");
            return;
        }

        const zipContent = await zip.generateAsync({ type: "blob" });
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(zipContent);
        downloadLink.download = `${sessionStorage.getItem(
            "processName"
        )}_${sessionStorage.getItem("projectName")}.zip`;
        downloadLink.click();
    }, [selectedFilesToProcess, data, rowSelection]);

    const TextDownloadButton = ({ disabled, content, fileName, file }) => {
        const isDisabled = disabled || !hasCompletedTranscription(file);
        
        const downloadTxt = () => {
            if (isDisabled) return;
            const blob = new Blob([JSON.stringify(content)], {
                type: "text/plain",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName + ".txt";
            link.click();
        };

        return (
            <button
                className="p-1 rounded-md border disabled:text-gray-300"
                disabled={isDisabled}
                onClick={downloadTxt}
                title={isDisabled ? "Transcription not completed yet" : "Download txt file"}
            >
                <ArrowDownTrayIcon className="h-5" />
            </button>
        );
    };

    const JsonDownloadButton = ({ disabled, content, fileName, file }) => {
        const isDisabled = disabled || !hasCompletedTranscription(file);
        
        const downloadJson = () => {
            if (isDisabled) return;
            const blob = new Blob([JSON.stringify(content)], {
                type: "application/json",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName + ".json";
            link.click();
        };

        return (
            <button
                className="p-1 rounded-md border disabled:text-gray-300"
                disabled={isDisabled}
                onClick={downloadJson}
                title={isDisabled ? "Transcription not completed yet" : "Download json file"}
            >
                <ArrowDownCircleIcon className="h-5" />
            </button>
        );
    };

    const columns = React.useMemo(
        () => [
            {
                id: "select",
                size: 10,
                header: ({ table }) => (
                    <IndeterminateCheckbox
                        {...{
                            checked: table.getIsAllRowsSelected(),
                            indeterminate: table.getIsSomeRowsSelected(),
                            onChange: table.getToggleAllRowsSelectedHandler(),
                        }}
                    />
                ),
                cell: ({ row }) => (
                    <center className="px-1">
                        <IndeterminateCheckbox
                            {...{
                                checked: row.getIsSelected(),
                                disabled: !row.getCanSelect(),
                                indeterminate: row.getIsSomeSelected(),
                                onChange: row.getToggleSelectedHandler(),
                            }}
                        />
                    </center>
                ),
            },
            {
                accessorKey: "index",
                enableColumnFilter: false,
                enableSorting: false,
                size: 50,
                header: "#",
                cell: ({ row }) => <center>{row.index + 1}</center>,
            },
            {
                accessorKey: "name",
                enableColumnFilter: false,
                size: 1000,
                header: () => <span>File Name</span>,
            },
            {
                accessorKey: "start_date_time",
                enableColumnFilter: false,
                size: 100,
                header: "Start Date",
                cell: ({ row }) => <div>{row.original.start_date_time}</div>,
            },
            {
                accessorKey: "last_modified",
                enableColumnFilter: false,
                size: 100,
                header: "End Date",
                cell: ({ row }) => (
                    <div>{row.original.last_modified !== "" && formattedDate(row.original.last_modified)}</div>
                ),
            },
            {
                accessorKey: "status",
                header: "Status",
                size: 50,
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    let statusText = row.original.status || "Waiting";
                    let statusColor = "bg-yellow-500";
                    let showSpinner = false;
                    const isPolling = pollingFiles.has(row.original.file_code);

                    if (row.original.status === "success") {
                        statusColor = "bg-green-500";
                    } else if (row.original.status === "error") {
                        statusColor = "bg-red-500";
                    } else if (row.original.status === "Inprogress" || row.original.status === "submitted") {
                        statusColor = "bg-blue-500";
                        showSpinner = true;
                        if (row.original.status === "submitted") {
                            statusText = "Processing";
                        }
                    }

                    return (
                        <div className="flex justify-center items-center gap-2">
                            <div
                                className={`${statusColor} text-white text-xs w-fit px-2 py-1 font-bold rounded-xl flex flex-nowrap items-center`}
                            >
                                {showSpinner && (
                                    <div className="h-3 w-3 border-t-transparent border-solid animate-spin rounded-full border-white border-2 me-1"></div>
                                )}
                                {statusText}
                                {(row.original.status === "Inprogress" || showSpinner) && "..."}
                            </div>
                            {isPolling && (
                                <button
                                    onClick={() => handleManualRefresh(row.original.file_code)}
                                    className="p-1 text-blue-600 hover:text-blue-800"
                                    title="Refresh status"
                                >
                                    <ArrowPathIcon className="h-4 w-4" />
                                </button>
                            )}
                        </div>
                    );
                },
            },
            {
                accessorKey: "transcription_model",
                enableColumnFilter: false,
                size: 100,
                header: "Model",
                cell: ({ row }) => (
                    <div>{row.original.transcription_model}</div>
                ),
            },
            {
                accessorKey: "id",
                header: "Actions",
                size: 50,
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => {
                    const canView = hasViewableTranscription(row.original);
                    const canDownload = hasCompletedTranscription(row.original);

                    return (
                        <div className="flex gap-2 items-center justify-center">
                            <TextDownloadButton
                                disabled={!canDownload}
                                content={row.original.response}
                                fileName={generateProcessCodeFileName(
                                    row.original.name,
                                    row.original.last_modified
                                )}
                                file={row.original}
                            />
                            <JsonDownloadButton
                                disabled={!canDownload}
                                content={row.original.response}
                                fileName={generateProcessCodeFileName(
                                    row.original.name,
                                    row.original.last_modified
                                )}
                                file={row.original}
                            />
                            <button
                                className={`p-1 rounded-md border ${
                                    canView 
                                        ? 'text-green-800 hover:bg-green-50' 
                                        : 'text-gray-300 cursor-not-allowed'
                                }`}
                                disabled={!canView}
                                onClick={() => openReadModal(row.original, "response")}
                                title={canView ? "View response" : "No response available"}
                            >
                                <EyeIcon className="h-5" />
                            </button>
                            <button
                                className={`p-1 rounded-md border ${
                                    canDownload 
                                        ? 'text-blue-800 hover:bg-blue-50' 
                                        : 'text-gray-300 cursor-not-allowed'
                                }`}
                                disabled={!canDownload}
                                onClick={() => openReadModal(row.original, "originalText")}
                                title={canDownload ? "View original transcribe text" : "Transcription not completed"}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-file-type">
                                    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
                                    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                                    <path d="M9 13v-1h6v1" />
                                    <path d="M12 12v6" />
                                    <path d="M11 18h2" />
                                </svg>
                            </button>
                        </div>
                    );
                },
            },
        ],
        [formattedDate, pollingFiles]
    );

    const table = useReactTable({
        data,
        columns,
        state: {
            rowSelection,
            sorting,
            globalFilter,
        },
        enableRowSelection: true,
        onRowSelectionChange: setRowSelection,
        onGlobalFilterChange: setGlobalFilter,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    const tableContainerRef = React.useRef(null);
    
    function Filter({ column }) {
        const columnFilterValue = column.getFilterValue();

        return (
            <input
                type="text"
                value={columnFilterValue || ""}
                onChange={(e) => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-full border rounded-md text-xs"
            />
        );
    }

    // const { rows } = table.getRowModel();
    // const rowVirtualizer = useVirtual({
    //     parentRef: tableContainerRef,
    //     size: rows.length,
    //     overscan: data.length,
    // });

    const { rows } = table.getRowModel();
    
    // const rowVirtualizer = useVirtualizer({
    // count: rows.length,
    // getScrollElement: () => tableContainerRef.current,
    // // overscan: pageSize,
    // estimateSize: () => 40, // ⬅️ REQUIRED (default size per row)
    // });

    const rowVirtualizer = useVirtualizer({
        count: rows.length,
        getScrollElement: () => tableContainerRef.current,
        estimateSize: () => 45,   // row height (adjust if needed)
        overscan: 10,
    });
    const virtualRows = rowVirtualizer.getVirtualItems();
    const totalSize = rowVirtualizer.getTotalSize();

    // const { virtualItems: virtualRows, totalSize } = rowVirtualizer;

    const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0 
    const paddingBottom =
        virtualRows.length > 0
            ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
            : 0;

    return (
        <div className="m-2 border rounded-lg bg-white font-GoogleSans tracking-wider overflow-hidden">
            <ReadModal
                isOpen={isOpenRead}
                closeModal={closeReadModal}
                title={modalTitle}
                modalInputs={
                    <div className="overflow-auto h-[calc(100vh-8rem)] md:h-[calc(100vh-8rem)]">
                        <pre className="pretxtwrap text-sm">
                            {typeof rowData === 'string' 
                                ? rowData 
                                : JSON.stringify(rowData, null, 2)
                            }
                        </pre>
                    </div>
                }
            />
            
            {pollingFiles.size > 0 && (
                <div className="bg-blue-50 border-b border-blue-200 px-4 py-2 flex items-center gap-2 text-sm text-blue-800">
                    <ClockIcon className="h-5 w-5 animate-pulse" />
                    <span>Checking for results... ({pollingFiles.size} file{pollingFiles.size > 1 ? 's' : ''} in progress)</span>
                </div>
            )}
            
            {selectedFilesToProcess.length === 0 && (
                <p className="px-3 py-4">
                    Please select the files for the transcription process.
                </p>
            )}
            {selectedFilesToProcess.length > 0 && (
                <>
                    <div className="flex justify-between m-3 gap-2">
                        <DebouncedInput
                            value={globalFilter ?? ""}
                            onChange={(value) => setGlobalFilter(String(value))}
                            placeholder="Search..."
                        />
                    </div>
                    <div
                        ref={tableContainerRef}
                        className="overflow-auto resp-processtable-h"
                    >
                        <table className="flex-inline w-full border-collapse">
                            <thead className="bg-gray-200 border-b">
                                {table.getHeaderGroups().map((headerGroup) => (
                                    <tr key={headerGroup.id}>
                                        {headerGroup.headers.map((header) => {
                                            return (
                                                <th
                                                    className="border p-3 whitespace-nowrap"
                                                    key={header.id}
                                                    colSpan={header.colSpan}
                                                    style={{
                                                        width: header.getSize(),
                                                    }}
                                                >
                                                    {header.isPlaceholder ? null : (
                                                        <>
                                                            <div
                                                                className={`${header.column.getCanSort()
                                                                    ? "cursor-pointer select-none justify-start"
                                                                    : "justify-center"
                                                                    } flex`}
                                                                onClick={header.column.getToggleSortingHandler()}
                                                            >
                                                                {flexRender(
                                                                    header
                                                                        .column
                                                                        .columnDef
                                                                        .header,
                                                                    header.getContext()
                                                                )}
                                                                {{
                                                                    asc: " 🔼",
                                                                    desc: " 🔽",
                                                                }[
                                                                    header.column.getIsSorted()
                                                                ] || null}
                                                            </div>
                                                            {header.column.getCanFilter() ? (
                                                                <div className="mt-2">
                                                                    <Filter
                                                                        column={
                                                                            header.column
                                                                        }
                                                                        table={
                                                                            table
                                                                        }
                                                                    />
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                {
                                    rows.length === 0 ?
                                        (
                                            <tr>
                                                <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
                                                    No Data Found
                                                </td>
                                            </tr>
                                        )
                                        :
                                        (
                                            <>
                                                {paddingTop > 0 && (
                                                    <tr>
                                                        <td
                                                            className="border p-3"
                                                            style={{
                                                                height: `${paddingTop}px`,
                                                            }}
                                                        />
                                                    </tr>
                                                )}
                                                {virtualRows.map((virtualRow) => {
                                                    const row = rows[virtualRow.index];
                                                    return (
                                                        <tr
                                                            key={row.id}
                                                            className="bg-white border-b transition duration-300 ease-in-out hover:bg-gray-100"
                                                        >
                                                            {row
                                                                .getVisibleCells()
                                                                .map((cell) => {
                                                                    return (
                                                                        <td
                                                                            className="border p-2 whitespace-nowrap"
                                                                            key={cell.id}
                                                                        >
                                                                            {flexRender(
                                                                                cell.column
                                                                                    .columnDef
                                                                                    .cell,
                                                                                cell.getContext()
                                                                            )}
                                                                        </td>
                                                                    );
                                                                })}
                                                        </tr>
                                                    );
                                                })}
                                                {paddingBottom > 0 && (
                                                    <tr>
                                                        <td
                                                            className="border p-3"
                                                            style={{
                                                                height: `${paddingBottom}px`,
                                                            }}
                                                        />
                                                    </tr>
                                                )}
                                            </>
                                        )
                                }
                            </tbody>
                        </table>
                    </div>
                </>
            )}
            {data.length > 0 && !startProcess && (
                <div className="flex gap-2 justify-start m-3">
                    <button
                        type="button"
                        onClick={downloadFiles}
                        className="inline-flex justify-center rounded-lg border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
                    >
                        <FolderArrowDownIcon
                            className="h-4"
                            title="Download zip file"
                        />{" "}
                        &nbsp;Download
                    </button>
                </div>
            )}
        </div>
    );
}